<template>
  <ContentWrap>
    <el-form :inline="true" :model="queryParams" class="-mb-15px">
      <el-form-item label="名称">
        <el-input v-model="queryParams.name" clearable class="!w-160px" @keyup.enter="handleQuery" />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="queryParams.status" clearable placeholder="全部" class="!w-140px">
          <el-option v-for="s in statusOptions" :key="s.value" :label="s.label" :value="s.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery"><Icon icon="ep:search" />搜索</el-button>
        <el-button type="primary" plain @click="openForm(undefined, 'create')"><Icon icon="ep:plus" />新建草稿</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>
  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column label="编号" prop="id" width="80" />
      <el-table-column label="名称" prop="name" min-width="140" />
      <el-table-column label="状态" prop="status" width="110">
        <template #default="{ row }">{{ statusLabel(row.status) }}</template>
      </el-table-column>
      <el-table-column label="开始" min-width="170">
        <template #default="{ row }">{{ formatDateTime(row.startTime) }}</template>
      </el-table-column>
      <el-table-column label="计划发车" min-width="170">
        <template #default="{ row }">{{ formatDateTime(row.cutTime) }}</template>
      </el-table-column>
      <el-table-column label="自提点" min-width="160">
        <template #default="{ row }">{{ pointNames(row) }}</template>
      </el-table-column>
      <el-table-column label="分摊运费" prop="deliveryFeeAmount" width="100" />
      <el-table-column label="佣金%" width="80">
        <template #default="{ row }">{{ row.commissionRate != null ? row.commissionRate : '默认' }}</template>
      </el-table-column>
      <el-table-column label="操作" width="320" fixed="right">
        <template #default="{ row }">
          <el-button link type="primary" @click="openForm(row.id, 'view')">详情</el-button>
          <el-button v-if="canEdit(row.status)" link type="primary" @click="openForm(row.id, 'edit')">
            编辑
          </el-button>
          <el-button link type="primary" @click="handleCopy(row.id)">复制开团</el-button>
          <el-button v-if="row.status === 'draft'" link type="success" @click="handlePublish(row.id)">发布</el-button>
          <el-button
            v-if="row.status === 'ongoing' || row.status === 'sold_out'"
            link
            type="warning"
            @click="handleDispatch(row.id)"
          >本波发车</el-button>
          <el-button
            v-if="row.status === 'draft' || row.status === 'preheat'"
            link
            type="danger"
            @click="handleCancel(row.id)"
          >取消</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="queryParams.pageNo"
      v-model:limit="queryParams.pageSize"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="formVisible" :title="formTitle" width="900px">
    <el-form ref="formRef" :model="formData" :rules="rules" label-width="110px" :disabled="!editable">
      <el-form-item label="活动名称" prop="name">
        <el-input v-model="formData.name" maxlength="64" placeholder="如：本周新鲜蔬菜团" />
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker v-model="formData.startTime" type="datetime" value-format="YYYY-MM-DD HH:mm:ss" class="!w-full" />
      </el-form-item>
      <el-form-item label="每日发车时刻" prop="cutTime">
        <el-date-picker
          v-model="formData.cutTime"
          type="datetime"
          value-format="YYYY-MM-DD HH:mm:ss"
          class="!w-full"
          placeholder="取时分作为每晚发车时刻；空则用租户默认 21:00"
        />
      </el-form-item>
      <el-form-item label="计划送达">
        <el-date-picker
          v-model="formData.planDeliveryTime"
          type="datetime"
          value-format="YYYY-MM-DD HH:mm:ss"
          class="!w-full"
        />
      </el-form-item>
      <el-form-item label="自提点" prop="pickupPointIds">
        <el-select
          v-model="formData.pickupPointIds"
          multiple
          filterable
          collapse-tags
          collapse-tags-tooltip
          class="!w-full"
          placeholder="请选择覆盖的自提点（可多选）"
        >
          <el-option v-for="p in points" :key="p.id" :label="p.pointName" :value="p.id!" />
        </el-select>
      </el-form-item>
      <el-form-item label="分摊运费(元)">
        <el-input-number v-model="formData.deliveryFeeAmount" :min="0" :precision="2" class="!w-full" />
      </el-form-item>
      <el-form-item label="团长佣金(%)">
        <el-input-number
          v-model="formData.commissionRate"
          :min="0"
          :max="100"
          :precision="0"
          class="!w-full"
          placeholder="空则用平台默认"
        />
      </el-form-item>
      <el-form-item label="活动商品" required>
        <div class="w-full">
          <div v-if="editable" class="mb-8px">
            <el-button type="primary" plain @click="spuSelectRef?.open()">
              <Icon icon="ep:plus" />从本店选商品
            </el-button>
            <span class="ml-8px text-12px text-[var(--el-text-color-secondary)]">
              先选商品，再勾规格；团购价默认带出售价，可改
            </span>
          </div>
          <el-table :data="formData.items || []" border size="small" empty-text="请点击上方按钮选择商品">
            <el-table-column label="商品" min-width="220">
              <template #default="{ row }">
                <div class="flex items-center gap-8px">
                  <el-image
                    v-if="row.picUrl"
                    :src="row.picUrl"
                    class="h-40px w-40px shrink-0 rounded"
                    fit="cover"
                  />
                  <div class="min-w-0">
                    <div class="truncate font-medium">{{ row.spuName || `商品#${row.spuId || '-'}` }}</div>
                    <div class="text-12px text-[var(--el-text-color-secondary)]">
                      {{ row.skuName || `SKU ${row.skuId}` }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="团购价(元)" width="150">
              <template #default="{ row }">
                <el-input-number
                  v-model="row.groupPrice"
                  :min="0.01"
                  :precision="2"
                  :controls="false"
                  class="!w-120px"
                  :disabled="!editable"
                />
              </template>
            </el-table-column>
            <el-table-column label="活动库存" width="130">
              <template #default="{ row }">
                <el-input-number
                  v-model="row.activityStock"
                  :min="0"
                  :controls="false"
                  class="!w-100px"
                  :disabled="!editable"
                />
              </template>
            </el-table-column>
            <el-table-column label="限购(0不限)" width="130">
              <template #default="{ row }">
                <el-input-number
                  v-model="row.perLimit"
                  :min="0"
                  :controls="false"
                  class="!w-100px"
                  :disabled="!editable"
                />
              </template>
            </el-table-column>
            <el-table-column v-if="editable" label="操作" width="70" fixed="right">
              <template #default="{ $index }">
                <el-button link type="danger" @click="formData.items!.splice($index, 1)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="formVisible = false">关闭</el-button>
      <el-button v-if="editable" type="primary" :loading="formLoading" @click="submitForm">
        {{ formData.status === 'preheat' ? '保存' : '保存草稿' }}
      </el-button>
    </template>
  </Dialog>

  <SpuSelect ref="spuSelectRef" :is-select-sku="true" :merchant="true" @confirm="onSpuConfirm" />
</template>

<script setup lang="ts">
import * as Api from '@/api/merchant/groupbuy'
import * as MerchantProductApi from '@/api/merchant/product'
import SpuSelect from '@/views/mall/promotion/components/SpuSelect.vue'
import { fenToYuanNumber } from '@/utils'
import { formatDate } from '@/utils/formatTime'
import type { FormInstance, FormRules } from 'element-plus'

defineOptions({ name: 'MerchantGroupbuyActivity' })

/** 接口毫秒时间戳 → 可读时间；失败显示 '-'，绝不回退成原始数字 */
const formatDateTime = (val?: string | number | Date | number[]) => {
  if (val === undefined || val === null || val === '') return '-'
  return formatDate(val as any) || '-'
}

/** 写入 date-picker：空则 '' */
const toPickerValue = (val?: string | number | Date | number[]) => {
  const text = formatDateTime(val)
  return text === '-' ? '' : text
}

/** 列表/表单展示用扩展字段（提交前剥离） */
type ActivityItemRow = Api.GroupbuyActivityItemVO & {
  spuName?: string
  skuName?: string
  picUrl?: string
}

const statusOptions = [
  { label: '草稿', value: 'draft' },
  { label: '预热', value: 'preheat' },
  { label: '进行中', value: 'ongoing' },
  { label: '已售罄', value: 'sold_out' },
  { label: '已截单(历史)', value: 'closed' },
  { label: '已取消', value: 'cancelled' },
  { label: '可提货(历史)', value: 'redeemable' },
  { label: '已结算', value: 'settled' }
]

const message = useMessage()
const loading = ref(false)
const list = ref<Api.GroupbuyActivityVO[]>([])
const total = ref(0)
const points = ref<Api.GroupbuyPickupPointVO[]>([])
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  name: undefined as string | undefined,
  status: undefined as string | undefined
})

const formVisible = ref(false)
const formLoading = ref(false)
const formRef = ref<FormInstance>()
const spuSelectRef = ref<InstanceType<typeof SpuSelect>>()
const formData = ref<Api.GroupbuyActivityVO & { items?: ActivityItemRow[] }>({
  name: '',
  startTime: '',
  cutTime: '',
  pickupPointIds: [],
  deliveryFeeMode: 1,
  deliveryFeeAmount: 0,
  commissionRate: undefined,
  items: []
})
type FormMode = 'create' | 'edit' | 'view'
const formMode = ref<FormMode>('view')
/** 未开卖可改：草稿、预热；开卖后只读 */
const canEdit = (status?: string) => status === 'draft' || status === 'preheat'
const editable = computed(() => formMode.value === 'create' || formMode.value === 'edit')
const formTitle = computed(() => {
  if (formMode.value === 'create') return '新建活动草稿'
  if (formMode.value === 'edit') return formData.value.status === 'preheat' ? '编辑活动' : '编辑草稿'
  return '活动详情'
})
const rules: FormRules = {
  name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
  startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
  cutTime: [{ required: true, message: '请选择计划发车参考时间', trigger: 'change' }],
  pickupPointIds: [
    {
      type: 'array',
      required: true,
      min: 1,
      message: '请至少选择一个自提点',
      trigger: 'change'
    }
  ]
}

const statusLabel = (status?: string) =>
  statusOptions.find((s) => s.value === status)?.label || status || '-'
const pointName = (id?: number) => points.value.find((p) => p.id === id)?.pointName || id || '-'
const pointNames = (row: Api.GroupbuyActivityVO) => {
  const ids =
    row.pickupPointIds?.length
      ? row.pickupPointIds
      : row.pickupPointId
        ? [row.pickupPointId]
        : []
  if (!ids.length) return '-'
  const labels = ids.map((id) => pointName(id))
  return labels.length <= 2 ? labels.join('、') : `${labels[0]} 等${labels.length}个`
}

const getList = async () => {
  loading.value = true
  try {
    const data = await Api.getActivityPage(queryParams)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}
const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}
const loadPoints = async () => {
  const data = await Api.getPickupPointPage({ pageNo: 1, pageSize: 100, status: 0 })
  points.value = data.list || []
}

const skuSpecText = (sku: any) => {
  const props = sku?.properties
  if (Array.isArray(props) && props.length) {
    return props.map((p: any) => p.valueName).filter(Boolean).join(' / ')
  }
  return sku?.name || `SKU ${sku?.id}`
}

/** 从本店选品确认：写入团购明细，默认团购价=售价 */
const onSpuConfirm = async (spuId: number, skuIds?: number[]) => {
  if (!skuIds?.length) {
    message.warning('请勾选至少一个规格')
    return
  }
  const spu = await MerchantProductApi.getSpu(spuId)
  const existIds = new Set((formData.value.items || []).map((i) => i.skuId))
  const added: ActivityItemRow[] = []
  for (const skuId of skuIds) {
    if (existIds.has(skuId)) continue
    const sku = (spu?.skus || []).find((s: any) => s.id === skuId)
    if (!sku) continue
    const saleYuan = fenToYuanNumber(sku.price ?? 0)
    added.push({
      skuId,
      spuId,
      groupPrice: saleYuan > 0 ? saleYuan : 0.01,
      activityStock: Math.max(sku.stock ?? 0, 0) || 10,
      perLimit: 0,
      spuName: spu?.name,
      skuName: skuSpecText(sku),
      picUrl: sku.picUrl || spu?.picUrl
    })
  }
  if (!added.length) {
    message.warning('所选规格已在活动中，或规格不存在')
    return
  }
  formData.value.items = [...(formData.value.items || []), ...added]
}

/** 编辑回显：补商品名/规格文案 */
const enrichItemLabels = async (items: ActivityItemRow[]) => {
  const spuIds = [...new Set(items.map((i) => i.spuId).filter(Boolean))] as number[]
  if (!spuIds.length) return
  try {
    const list = (await MerchantProductApi.getSpuDetailList(spuIds)) as any[]
    const bySpu = new Map((list || []).map((s) => [s.id, s]))
    for (const item of items) {
      const spu = bySpu.get(item.spuId!)
      if (!spu) continue
      item.spuName = spu.name
      item.picUrl = spu.picUrl
      const sku = (spu.skus || []).find((s: any) => s.id === item.skuId)
      if (sku) {
        item.skuName = skuSpecText(sku)
        item.picUrl = sku.picUrl || spu.picUrl
      }
    }
  } catch {
    /* 展示降级为 SKU id */
  }
}

const openForm = async (id?: number, mode: FormMode = 'view') => {
  await loadPoints()
  formMode.value = mode
  if (id) {
    const data = await Api.getActivity(id)
    const pickupPointIds =
      data.pickupPointIds?.length
        ? data.pickupPointIds
        : data.pickupPointId
          ? [data.pickupPointId]
          : []
    // date-picker 需要 YYYY-MM-DD HH:mm:ss，不能直接塞毫秒时间戳
    formData.value = {
      ...data,
      pickupPointIds,
      items: data.items || [],
      startTime: toPickerValue(data.startTime),
      cutTime: toPickerValue(data.cutTime),
      planDeliveryTime: toPickerValue(data.planDeliveryTime)
    }
    await enrichItemLabels(formData.value.items as ActivityItemRow[])
    if (mode === 'edit' && !canEdit(formData.value.status)) {
      formMode.value = 'view'
    }
  } else {
    formMode.value = 'create'
    formData.value = {
      name: '',
      startTime: '',
      cutTime: '',
      pickupPointIds: [],
      deliveryFeeMode: 1,
      deliveryFeeAmount: 0,
      commissionRate: undefined,
      items: []
    }
  }
  formVisible.value = true
}

const toSavePayload = (): Api.GroupbuyActivityVO => {
  const items = (formData.value.items || []).map((i) => ({
    id: i.id,
    skuId: i.skuId,
    spuId: i.spuId,
    groupPrice: i.groupPrice,
    activityStock: i.activityStock,
    perLimit: i.perLimit ?? 0
  }))
  const pickupPointIds = formData.value.pickupPointIds || []
  return {
    ...formData.value,
    items,
    pickupPointIds,
    // 兼容旧字段：首个点
    pickupPointId: pickupPointIds[0]
  }
}

const submitForm = async () => {
  await formRef.value?.validate()
  if (!formData.value.items?.length) {
    message.warning('请至少选择一个活动商品')
    return
  }
  if (formData.value.items.some((i) => !i.skuId || !i.groupPrice)) {
    message.warning('请完善团购价')
    return
  }
  formLoading.value = true
  try {
    const payload = toSavePayload()
    if (payload.id) {
      await Api.updateActivity(payload)
    } else {
      await Api.createActivity(payload)
    }
    message.success('已保存')
    formVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}
const handlePublish = async (id: number) => {
  await message.confirm('确认发布该活动？')
  await Api.publishActivity(id)
  message.success('已发布')
  await getList()
}
const handleCopy = async (id: number) => {
  await message.confirm('将复制商品、自提点和价格到一场新草稿，原活动不变。')
  const newId = await Api.copyActivity(id)
  message.success('已生成草稿，请改时间后发布')
  await getList()
  if (newId) {
    await openForm(newId, 'edit')
  }
}
const handleDispatch = async (id: number) => {
  await message.confirm('确认对本波已支付未入批订单发车？活动将继续在架售卖。')
  await Api.dispatchWaveActivity(id)
  message.success('已发车聚批')
  await getList()
}
const handleCancel = async (id: number) => {
  await message.confirm('确认取消该活动？')
  await Api.cancelActivity(id)
  message.success('已取消')
  await getList()
}

onMounted(async () => {
  await loadPoints()
  await getList()
})
</script>
